import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@pella/sash-framework';
import { CTA } from '../../../';
import LoginForm from '../../../page/account/common/login-form';
import { useAccount } from '../../../../hooks/use-account';
import { navigate } from 'gatsby';

const SiteAccount = ({ accountData, onAuthCloseModal, userSignedIn }) => {
	const { logout } = useAccount();

	const logOut = async (e) => {
		e.preventDefault();
		await logout();
		navigate('/account/login/');
	};

	if (userSignedIn) {
		return (
			<List
				bullets='none'
				className='accountList space-y-2'
			>
				{accountData?.cta?.[0] &&
					accountData.cta.map((item, index) => (
						<li
							key={index}
							className={`leading-none ${item.link.title === 'Sign Out' ? '!mt-4 border-t border-t-neutral-200 pt-4' : ''}`}
						>
							<CTA
								data={item}
								onClick={item.link.title === 'Sign Out' ? logOut : null}
								className='inline-flex items-center no-underline [&>span]:mr-2.5'
							/>
						</li>
					))}
			</List>
		);
	} else {
		return (
			<LoginForm
				type='isDropdown'
				onAuthCloseModal={onAuthCloseModal}
				className='header-loginForm block max-h-[calc(100vh-61px)] overflow-auto max-sm:max-h-none max-sm:!p-2.5 [&_h2]:hidden sm:[&_h2]:block [&_span]:hidden sm:[&_span]:block'
			/>
		);
	}
};

SiteAccount.propTypes = {
	userSignedIn: PropTypes.bool,
	onAuthCloseModal: PropTypes.func,
	accountData: PropTypes.object,
};

export default SiteAccount;
